import Vue from 'vue'
import Router from 'vue-router'
import billIssue from './bill-issue.js'
import billPayment from './bill-payment.js'
import inquiry from './inquiry.js'
import circulation from './circulation.js'
import review from './review.js'
import test from './test.js'
import system from './system.js'
import account from './account.js'
import security from './security.js'
import bank from './bank.js'
import message from './message.js'
import billManage from './bill-manage.js'
import web from './web.js'
import mobile from './mobile.js'
const home = () => import ('@/components-frame/home')
const main = () => import ('@/pages/main')
const login = () => import ('@/components-frame/login')
const notFound = () => import ('@/components-frame/not-found')
const register = () => import ('@/components-frame/register')
const loginForm = () => import ('@/components-frame/login-form')
const forgetPasswd = () => import('@/components-frame/forget-passwd')
const withdraw = () => import('@/pages/withdraw/withdraw')

Vue.use(Router)

/**
 * 现默认是不开启tab模式，打开tab方法：/src/config.js 文件里的 isTab：true
本系统tab默认为导航菜单的全集，所以不包含其他非导航页面，如果要加需在route配置meta中增加 {title:"祺信详情"，notMenu:true}
要想达到tab的作用，即切换页面可缓存，不用刷新数据，需做下面的处理：
        在需要缓存的页面配置router时，保证路由name和组件name相同，meta项配置keepAlive:true
 */

export default new Router({
	mode: 'history',
  routes: [
    ...web,
    ...mobile,
    {
      path: '/',
      redirect:"/login"
    },
    {
      path: '/login',
      component: login,
      meta: {public: true},
      children:[
        {
          path: '/',
          component: loginForm,
          meta: {public: true}
        },
        {
          path: 'register',
          component: register,
          meta: {public: true}
        }
      ]
    },
    {
      path: '/forget-passwd',
      name: 'forgetPasswd',
      component: forgetPasswd,
      meta: {
        public: true,  // 表示进入这个路由是不需要登录的
      }
    },
    {
      path: '',
      name: 'user',
      component: home,
      children: [
        {
          path: '/main',
          name: 'main',
          component: main
        },
        ...billIssue,
        ...billPayment,
        ...inquiry,
        ...circulation,
        ...review,
        ...system,
        ...account,
        ...security,
        ...test,
        ...bank,
        ...message,
        ...billManage,
        {
          path: 'withdraw',
          name: 'withdraw',
          component: withdraw

        },
        {
          path: '*',
          name: 'notFound',
          component: notFound
        }
      ]
    },
    {
      path: '*',
      name: 'notFound',
      component: notFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js